module.exports = __webpack_public_path__ + "static/img/zd10.147158d5.svg";